{
  "fr": {
    "space": {
      "actions": {
        "assignOtherUnit": "Reassigner à une Unité",
        "assignSpace": "Assigner Espace",
        "assignUnit": "Assigner à une Unité",
        "cancel": "Annuler",
        "closeEdit": "Fermer Modifier",
        "create_space": "Ajouter Espace",
        "delete": "Supprimer",
        "edit": "Modifier",
        "goToSpaces": "Créez de nouveaux espaces",
        "new": "Espace",
        "save": "Enregistrer",
        "unassign": "Désassigner Unité",
        "unassignSpaces": "Unassign Spaces"
      },
      "attributes": {
        "category": "Type",
        "description": "Description",
        "level": "Niveau",
        "name": "Name",
        "price_value": "Total prix de vente",
        "price_value_construction": "Quote part Construction",
        "price_value_land": "Quote part Terrain",
        "quotity": "Quotité partielle",
        "status": "Status",
        "unit": "Unité"
      },
      "category": {
        "bicyclestorage": "Stockage de vélo",
        "cellar": "Cave",
        "garagebox": "Box de Garage",
        "other": "Autre",
        "outdoor_space": "Espace Extérieur",
        "parkinglot": "Parking",
        "storage": "Débarras",
        "winecellar": "Cave à vin"
      },
      "labels": {
        "allSpacesAssigned": "Tous les espaces ont été assignés à une unité.",
        "assignedSpaces": "Espaces Assignés",
        "internal": "Interne",
        "noCategory": "Aucun type défini",
        "noSpaceAssigned": "Pas d'espaces attribués",
        "noSpaces": "Pas encore d'espaces",
        "notAssignedToUnit": "Non affecté à l'unité",
        "onlyAvailableSpacesShown": "Seuls les espaces disponibles sont affichés",
        "selectToUnassign": "Sélectionner pour annuler l'attribution",
        "space": "Espace",
        "spaces": "Espaces",
        "spacesProject": "Espaces dans Projet {project}",
        "unassignedSpaces": "Espaces Non Assignés"
      },
      "validation": {
        "needCategory": "Catégorie requise",
        "needName": "Nom requis",
        "needNumber": "Doit être un nombre (par exemple 95)",
        "selectSpace": "Sélectionnez au moins 1 espace"
      }
    }
  }
}